export function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('CloudCoverDB', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            if (!db.objectStoreNames.contains('sessionCache')) {
                db.createObjectStore('sessionCache');
            }
        };
        request.onsuccess = (e) => resolve(e.target.result);
        request.onerror = () => reject('Failed to open DB');
    });
}

export async function setItem(key, value) {
    const db = await openDB();
    const tx = db.transaction('sessionCache', 'readwrite');
    const sessionCache = tx.objectStore('sessionCache');
    sessionCache.put(value, key);
    return tx.complete;
}

export async function getItem(key) {
    const db = await openDB();
    const tx = db.transaction('sessionCache', 'readonly');
    const sessionCache = tx.objectStore('sessionCache');
    return new Promise((resolve, reject) => {
        const request = sessionCache.get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject('Failed to get item');
    });
}
export async function clearExpiredItems() {
    const request = indexedDB.deleteDatabase("CloudCoverDB");
    request.onsuccess = () => {};
    request.onerror = () => {};
    request.onblocked = () => {};
}
export async function clearAllRestoreIndexedDB() {
    const db = await openDB();
    const transaction = db.transaction(['sessionCache'], 'readwrite');
    const objectStore = transaction.objectStore('sessionCache');

    const request = objectStore.openKeyCursor();

    request.onsuccess = async function (event) {
        const cursor = event.target.result;
        if (cursor) {
            const key = cursor.key;
            if (typeof key === 'string' && key.startsWith('RestorePage_')) {
                objectStore.delete(key);
            }
            cursor.continue();
        }
    };

    request.onerror = function (event) {
        console.error("Error clearing RestorePage keys:", event.target.error);
    };
}


export async function removeItem(key) {
    const db = await openDB();
    const tx = db.transaction('sessionCache', 'readwrite');
    const sessionCache = tx.objectStore('sessionCache');
    sessionCache.delete(key);
    return tx.complete;
}